const CheckoutActions = {
  NEW_CARD: 'NEW_CARD',
  RELOAD_CARD: 'RELOAD_CARD',
};

export default CheckoutActions;
